import React, { useEffect } from "react";
import TimePicker from "rc-time-picker";
import FontAwesome from "react-fontawesome";
import inputStyles from "./TimeInput.module.scss";
import overlayStyles from "./TimeOverlay.module.scss";
import classNames from "classnames/bind";
import config from "../../../config";
import moment, { Moment } from "moment";
import FormInputWrapper from "../FormInputWrapper";
import { ControlledTimeInputProps, TimeInputProps } from "./types";
import FormIcon from "../FormIcon";

const inputCx = classNames.bind(inputStyles);
const overlayCx = classNames.bind(overlayStyles);

/**
 * @deprecated use "DateSelector" instead (see Storybook documentation)
 */
export const TimeInput = ({
  onChange,
  onBlur,
  value,
  format = config.TIME_FORMAT,
  isDisabled,
  showIcon,
  error,
  inputRef,
  id,
  name,
  placeholder,
  use12Hours = false,
  showSecond = true,
}: TimeInputProps) => {
  useEffect(() => {
    const input = document.querySelector<HTMLInputElement>(
      `.${inputCx("input")} input`
    );
    if (input) {
      input.setAttribute("autocomplete", "off");
      inputRef?.(input);
    }
  }, []);

  const onTimeChange = (newTime: Moment) => {
    onChange?.(newTime?.toDate() ?? undefined);
  };

  const clearIcon = (
    <div className={inputCx("icon", "icon--clear")}>
      <FontAwesome name="times" />
    </div>
  );

  return (
    <TimePicker
      className={inputCx("input", "timeInput", {
        "input--disabled": isDisabled,
        "input--error": error,
      })}
      popupClassName={overlayCx("overlay", "timeOverlay", {
        "overlay--wide": showSecond && use12Hours,
      })}
      id={id}
      name={name}
      placeholder={placeholder}
      disabled={isDisabled}
      inputIcon={
        showIcon && (
          <FormIcon
            isAbsolutelyPositionedToRight
            error={error}
            isDisabled={isDisabled}
            name="clock-o"
          />
        )
      }
      clearIcon={clearIcon}
      onChange={onTimeChange}
      onClose={onBlur}
      format={format}
      value={value ? moment(value) : undefined}
      use12Hours={use12Hours}
      showSecond={showSecond}
    />
  );
};

/**
 * @deprecated use "DateSelector" instead (see Storybook documentation)
 */
const ControlledTimeInput = (props: ControlledTimeInputProps) => {
  return (
    <FormInputWrapper
      {...props}
      as={TimeInput}
    />
  );
};

export default ControlledTimeInput;
